import Ajax from '../ajax';

export default {
  getList: () => Ajax('get', 'paymentMethod'),
};
